import { Observable } from 'rxjs';
import { RemoteWallboxFirmwareUpdate } from '../../../../models/RemoteWallboxFirmwareUpdate';
import { AdvancedHttpClient } from '../../http/AdvancedHttpClient';
import { WebDataRepository } from '../base/WebDataRepository';
import { OfflineUpdateDetail } from '../updates/UpdatesRepository';
import { IUkUpdatesRepository } from './IUkUpdatesRepository';

export class UkUpdatesRepository
  extends WebDataRepository<RemoteWallboxFirmwareUpdate>
  implements IUkUpdatesRepository
{
  constructor(public override httpClient: AdvancedHttpClient) {
    super(httpClient, 'updates');
  }

  public checkFirmwareUpdateOffline(
    serialNumber: string,
    model: string,
    version: string
  ): Observable<OfflineUpdateDetail | undefined> {
    // undefined, when no update is available
    // request currently not in use:
    // let header: RequestParams = {
    //   'X-API-KEY': environment.api.updateApiKey as string,
    //   'X-API-SECRET': environment.api.updateApiSecret as string,
    // };

    let req = this.httpClient.get<OfflineUpdateDetail | undefined>({
      url: `/offline?serial=${serialNumber}&model=${model}&version=${version}`,
      // headers: header,
    });
    return req;
  }
}
